import RestaurantCard, { closedRestaurant } from "./RestaurantCard"
import resList from "../utils/mockData"
import { useEffect, useState,useContext } from "react"
import Shimmer from "./Shimmer"
import { Link } from "react-router-dom"
// import { RESTAURANTS_API } from "../utils/constants"
import useOnlineStatus from "../utils/useOnlineStatus"
import useRestaurants from "../utils/useRestaurants"
import { RESTAURANTS_API } from "../utils/constants"
import UserContext from "./UserContext"
const Body = () => {
  console.log("render body")
  const [listOfRestaurants, setListOfRestaurants] = useState([])
  const [filteredRestaurants, setFilteredRestaurants] = useState([])
  const [searchText, setSearchText] = useState("")

  const {loggedInUser,setUserName}=useContext(UserContext)
  const RestaurantCardClose = closedRestaurant(RestaurantCard)
  useEffect(() => {
    fetchRestaurants()
  }, [])
  //console.log(jsonData);
  // I failed to find out why following call causes an error
  //const json = useRestaurants()
  const fetchRestaurants = async () => {
    const data = await fetch(RESTAURANTS_API).catch((err) => {
      console.log(err.essage)
    })
    const jsonData = await data?.json().catch((err) => {
      console.log(err.message)
    })
    const restaurants =
      jsonData?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle
        ?.restaurants
    if (Array.isArray(restaurants)) {
      console.log("restau :", restaurants)
      setListOfRestaurants(restaurants)
      setFilteredRestaurants(restaurants)
    } else {
      setListOfRestaurants([])
      setFilteredRestaurants([])
    }
  }
 
  // console.log(card.card.card.gridElements.infoWithStyle.restaurants);

  // if (listOfRestaurants.length === 0) {
  //   return <Shimmer />;
  // }
  //conditional rendering
  //const status = useOnlineStatus()
  // || !status
  return filteredRestaurants.length === 0 ? (
    <div className="flex-wrap justify-between dark:bg-slate-700">
      <input
        className="w-[300px] ml-60 my-4 border-dotted border-black bg-transparent shadow-lg p-3"
        placeholder="Search Restaurant!😋 "
        value={searchText}
        onChange={(e) => {
          setSearchText(e.target.value)
        }}
      />
      <button
        className=" px-4 hover:bg-white border-2 bg-slate-800 border-dotted text-yellow-500 items-center shadow-lg"
        onClick={() => {
          //console.log(searchText);
          const searchedList = listOfRestaurants.filter((x) => {
            // {console.log(x.info.id)}
            // {console.log(x.info.name)}
            return x?.info?.name
              .toLowerCase()
              .includes(searchText.toLowerCase())
          })
          setFilteredRestaurants(searchedList)
        }}
      >
        Search
      </button>
      <Shimmer />
    </div>
  ) : (
    <div className="body dark:bg-slate-700">
      <div className="filter flex justify-between">
        <button
          className="px-4 hover:bg-white border-2 bg-slate-800 border-dotted text-yellow-500 items-center shadow-lg rounded-lg"
          onClick={() => {
            const filteredList = listOfRestaurants.filter((x) => {
              return x.info.avgRating > 4.2
            })
            setFilteredRestaurants(filteredList)
            console.log(listOfRestaurants)
          }}
        >
          Top Rated Restaurants
        </button>
        <input
          className="w-[400px] py-2 ml-60 my-4 border-dotted border-black bg-transparent shadow-lg px-2"
          placeholder="   Search restaurants😋"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value)
          }}
        />
        <button
          className="px-7 py-2 hover:bg-white border-2 bg-slate-800 border-dotted text-yellow-500 items-center shadow-lg rounded-lg mr-[500px]"
          onClick={() => {
            //console.log(searchText);
            const searchedList = listOfRestaurants.filter((x) => {
              // {console.log(x.info.id)}
              // {console.log(x.info.name)}
              return x?.info?.name
                .toLowerCase()
                .includes(searchText.toLowerCase())
            })
            setFilteredRestaurants(searchedList)
          }}
        >
          Search
        </button>
        {/* <input className="m-2 p-2 shadow-lg" placeholder="write name" value={loggedInUser} onChange={(e)=>setUserName(e.target.value)}/> */}
      </div>
      <div className="flex flex-wrap ml-16">
        {filteredRestaurants.map((restaurant) => {
          console.log(restaurant.info.id)
          return (
            <Link
              to={`/restaurants/${restaurant.info.id}`}
              key={restaurant.info.id}
            >
              {
                //But at this moment in swiggy's api restaurant.info.promoted is not present
                restaurant?.info?.isOpen ? (
                  <RestaurantCard resData={restaurant} />
                  
                ) : (
                  <RestaurantCardClose resData={restaurant} />
                )
              }
            </Link>
          )
        })}
        {/* <RestaurantCard resName="MFC" img="https://www.panningtheglobe.com/wp-content/uploads/2013/02/chinese-ham-and-egg-fried-rice-web.jpg"  cuisine="Chinese" delivaryTime="35 minutes" rating="4.5" />
          <RestaurantCard resName="Bengali Hotel" img="https://glebekitchen.com/wp-content/uploads/2019/10/murghirjholfrontlow2.jpg" cuisine="curry, rice, Dal" delivaryTime="20 minutes" rating="4.1" /> 
          <Link to={"/restaurants/"+restaurant.info.id} key={restaurant.info.id}><RestaurantCard resData={restaurant} /></Link>
          */}
      </div>
    </div>
  )
}

export default Body
